/*
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2022-09-07 14:59:51
 * @LastEditTime: 2022-12-04 14:34:12
 * @LastEditors: chenguobiao
 */

// const CSS = {
//   'alpha': 'alpha-d2270',
//   'black': 'black-3c85d',
//   'board': 'board-b72b1',
//   'chessboard': 'chessboard-63f37',
//   'sparePieces': 'spare-pieces-7492f',
//   'square': 'square-55d63'
// }
// class ChessBoard {
//   constructor(containerElOrString, config) {
//     this._init(containerElOrString, config)
//   }
//   _init(containerElOrString, config) {
//     this.$container = $(containerElOrString)
//     this.$board = this.$container.find('.' + CSS.board)
//     this.config = config
//     this.board = window.ChessBoard(containerElOrString, {
//       ...config,
//       draggable: config.mode === 'drag'
//     })
//     this.addEvents()
//   }
//   addEvents() {
//     console.log('this.config.mode', this.config.mode)
//     if (this.config.mode === 'click') {
//       this.$board.on('click', '.' + CSS.square, function () {
//         console.log('===============')
//       })
//     }
//   }
//   getBoard() {
//     return this.board
//   }
// }
var CSS = {}
CSS['alpha'] = 'alpha-d2270'
CSS['black'] = 'black-3c85d'
CSS['board'] = 'board-b72b1'
CSS['chessboard'] = 'chessboard-63f37'
CSS['clearfix'] = 'clearfix-7da63'
CSS['highlight1'] = 'highlight1-32417'
CSS['highlight2'] = 'highlight2-9c5d2'
CSS['notation'] = 'notation-322f9'
CSS['numeric'] = 'numeric-fc462'
CSS['piece'] = 'piece-417db'
CSS['row'] = 'row-5277c'
CSS['sparePieces'] = 'spare-pieces-7492f'
CSS['sparePiecesBottom'] = 'spare-pieces-bottom-ae20f'
CSS['sparePiecesTop'] = 'spare-pieces-top-4028b'
CSS['square'] = 'square-55d63'
CSS['white'] = 'white-1e1d7'

function CustomChessboard(containerElOrString, config, expandConfig) {
  var mode = expandConfig.mode
  var $container = null
  var $board = null
  var $sourceSquare = null // 待移动棋子所在广场
  var $sourcePiece = null
  const { player_turn, removeHighlightValidSquare, highlightValidSquare } =
    expandConfig
  const widget = window.ChessBoard(containerElOrString, {
    ...config,
    draggable: mode === 'drag',
  })
  var canMoves = null
  function isFunction(f) {
    return typeof f === 'function'
  }
  function deepCopy(thing) {
    return JSON.parse(JSON.stringify(thing))
  }
  function validPiece($piece) {
    const piece = $piece.attr('data-piece')
    return piece ? piece.indexOf(player_turn) > -1 : $sourceSquare
  }
  function piecesUpAndDownAnimation(type) {
    if (!$sourcePiece) return

    if (type === 'up') {
      const image = document.createElement('img')
      image.src = require('./heightlight-bg.png')
      image.style = 'position: absolute; width: 0.93rem;height:  0.93rem;'
      image.className = 'heightlight-bg'
      $sourceSquare.append(image)
    } else {
      $sourceSquare.find('.heightlight-bg').remove()
    }
  }
  function handlePiecesUp($square, $piece) {
    if ($sourcePiece) {
      const sourcePiece = $sourcePiece.attr('data-piece')
      const piece = $piece.attr('data-piece')
      piecesUpAndDownAnimation('down')
      $sourcePiece = null
      if (sourcePiece === piece) return
    }
    $sourcePiece = $piece
    $sourceSquare = $square
    piecesUpAndDownAnimation('up')
    const source = $square.attr('data-square')
    const piece = $sourcePiece.attr('data-piece')
    const currentPosition = widget.position()
    isFunction(config.onDragStart) &&
      config.onDragStart(
        source,
        piece,
        currentPosition,
        currentPosition === false,
      )
  }
  function handlePiecesDown($square) {
    if (!$sourceSquare) return
    piecesUpAndDownAnimation('down')
    const source = $sourceSquare.attr('data-square')
    const target = $square.attr('data-square')
    const piece = $sourcePiece.attr('data-piece')
    const currentPosition = widget.position()
    const oldPosition = deepCopy(currentPosition)
    const newPosition = deepCopy(currentPosition)
    newPosition[target] = piece
    widget.move(source + '-' + target)
    config.onDrop(source, target, piece, newPosition, oldPosition)
    $sourceSquare = null
    $sourcePiece = null
  }
  function handleHighlightValidSquare($square) {
    const square = $square.attr('data-square')
    const moves = expandConfig.game.moves({
      square: square,
      verbose: true,
    })
    console.log('moves', moves)
    canMoves = moves.map((move) => move.to)

    if (moves.length === 0) return
    for (var i = 0; i < moves.length; i++) {
      const move = moves[i]
      highlightValidSquare(move.to)
    }
  }
  function handleRemoveHighlightValidSquare() {
    removeHighlightValidSquare()
    canMoves = null
  }
  // function isCanMove() {}
  function handleClick(evt) {
    const $square = $(this)
    const $piece = $(this).find('.' + CSS.piece)
    const turn = expandConfig.game.turn()
    const piece = $piece.attr('data-piece') || ''
    const square = $square.attr('data-square') || ''
    const sourcePiece = $sourcePiece ? $sourcePiece.attr('data-piece') : ''
    const sourceSquare = $sourceSquare ? $sourceSquare.attr('data-square') : ''
    if (
      (!sourceSquare &&
        ((turn === 'w' && piece.search(/^b/) !== -1) ||
          (turn === 'b' && piece.search(/^w/) !== -1) ||
          turn !== player_turn)) ||
      (sourceSquare &&
        piece[0] !== sourcePiece[0] &&
        canMoves &&
        canMoves.indexOf(square) === -1)
    ) {
      return
    }
    handleRemoveHighlightValidSquare()
    // 起子
    if (square !== sourceSquare && $piece.length > 0 && validPiece($piece)) {
      handleHighlightValidSquare($square)
      handlePiecesUp($square, $piece)
    } else {
      // 落子
      handlePiecesDown($square)
    }
  }
  function init() {
    $container = $(containerElOrString)
    $board = $container.find('.' + CSS.board)
    if (mode === 'click') {
      $board.on('click', '.' + CSS.square, handleClick)
    }
  }
  init()
  return widget
}
export default CustomChessboard
